import { PackageStatusEnum } from "@/__generated__/graphql";
import { Badge } from "@/components/ui";
import { useMemo } from "react";
import type { BadgeVariant } from "@/components/ui/badge";
import { Typography } from "../typography";
import { packageStatusLabel } from "./lib";

export function PackageStatusBadge({ status }: { status: PackageStatusEnum }) {
  const { variant, color } = useMemo(() => {
    let variant: BadgeVariant = "primary";
    let color: string = "color-brand-primary text-brand-primary";

    switch (status) {
      case PackageStatusEnum.Active:
        variant = "primary";
        color = "text-brand-primary";
        break;
      default:
        variant = "neutral";
        color = "text-foreground-intermediate";
        break;
    }

    return { variant, color };
  }, [status]);

  return (
    <Badge variant={variant}>
      <Typography variant="caption-sm" numberOfLines={1} className={color}>
        {packageStatusLabel(status)}
      </Typography>
    </Badge>
  );
}
